<template>
  <div class="content-main">
    <section id="uso-cientifico">
      <div class="row">
        <div class="col-lg-12">
          <div class="section-title-index">
            <h2>Uso científico</h2>
          </div>
          <p>
            Diante da manifestação de interesse de estudantes de graduação e
            pós-graduação de utilizar o <strong>eSUS Feedback</strong> como
            metodologia ou então citá-lo no uso de seus dados para realizar
            estudos e trabalhos científicos voltados para o Monitoramento e
            Avaliação na APS, bem como outras temáticas relacionadas. Estamos
            disponibilizando essa compilação de diferentes produções acadêmicas.
          </p>
          <p>
            Cada produção científica listada está identificada com seu tipo,
            título, autor principal e ano de publicação, facilitando o acesso e
            consolidando ainda mais o <strong>eSUS Feedback</strong> no que diz
            respeito a confiabilidade dos dados apresentados e disponibilizados,
            tanto na área restrita como na área pública.
          </p>
          <Tabela
            ref="table"
            :cadastros="displayedCadastros"
            :loading="table.loading"
            @filterSearch="filterSearch($event)"
          />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Tabela from './Tabela.vue'

export default {
  name: 'UsoCientifico',
  components: {
    Tabela,
  },
  mounted() {},
  data() {
    return {
      filterSearchTable: false,
      table: {
        items: [],
        loading: false,
      },
    }
  },
  computed: {
    displayedCadastros() {
      if (this.filterSearchTable != false) {
        return this.filterSearchTable
      }
      return this.table.items
    },
  },
  methods: {
    filterSearch(item) {
      if (item.filter !== false) {
        this.filterSearchTable = item.filter
        return
      }
      this.filterSearchTable = false
    },
  },
  mounted() {
    this.table.items = [
      {
        id: '1',
        tipo: 'TCC',
        titulo:
          'Um relato de experiência exitosa da implantação do monitoramento e avaliação dos indicadores do Previne Brasil em um município do interior do Estado da Bahia',
        autor: 'FRANCISCO AUBER PERGENTINO VIEIRA',
        autores: [
          'FRANCISCO AUBER PERGENTINO VIEIRA',
          'LUCIANO MONTALVÃO TEIXEIRA',
          'MARCUS VINÍCIUS DIAS GADELHA',
        ],
        ano: '2022',
        resumo: `Trata-se de uma proposta de trabalho como relato de experiência sobre as ações de
monitoramento e avaliação dos indicadores de desempenho do novo financiamento,
o programa Previne Brasil, no nível da Atenção Primária à Saúde, no município de
Presidente  Jânio  Quadros,  localizado  na  região  sudoeste,  no  interior  do  Estado  da
Bahia.  Este  estudo  tem  como  finalidade  relatar  estas  ações  para  qualificar  os
cadastros individuais, os registros dos atendimentos e procedimentos individuais, e o
monitoramento e avaliação dos indicadores com o objetivo de alcançar a cobertura
mínima daqueles  que nunca haviam  alcançados e elevar  aqueles já  alcançados. A
partir do relato desta vivência, espera-se que haja a produção de estudos científicos
descrevendo  a  correlação  das  ações  de  educação  permanente  em  saúde  e  do
monitoramento e avaliação dos indicadores do Previne Brasil.
`,
        doi: '',
        link: '',
        url: 'https://bitrix24public.com/biaticefb.bitrix24.com.br/docs/pub/a52ca4966d517633e8cf38aaf22f4031/default/?&',
      },
      {
        id: '2',
        tipo: 'Artigo científico',
        titulo:
          'Perfil dos usuários diabéticos atendidos em uma unidade básica de saúde no sertão paraibano',
        autor: 'Eloizy Mariana Dias de Medeiros Cirilo Costa',
        autores: [
          'Eloizy Mariana Dias de Medeiros Cirilo Costa',
          'Milena Nunes Alves de Sousa',
        ],
        ano: '2023',
        resumo:
          'O diabetes mellitus é um relevante e crescente problema de saúde pública para todos os países, independentemente do seu grau de desenvolvimento socioeconômico. Representa uma importante carga financeira para os cofres públicos em razão das maiores taxas de hospitalizações, maior utilização dos serviços de saúde, gastos com terapêutica medicamentosa, perda de produtividade e cuidados prolongados para tratamento de complicações. O presente estudo tem a finalidade de reconhecer o perfil clínico-epidemiológico dos usuários diabéticos atendidos em uma unidade básica de saúde no sertão paraibano. Trata-se de um estudo do tipo transversal, descritivo, com abordagem quantitativa que utilizará dados secundários existentes em prontuário eletrônico, coletados a partir de um questionário contendo variáveis para caracterização sociodemográfica e investigação de aspectos clínicos. Obteve-se uma amostra de 141 diabéticos com idade média de 62,7 anos, sendo a maioria do sexo feminino e categorizados como diabéticos tipo 2. Em relação às comorbidades, descaram-se hipertensão arterial sistêmica e dislipidemia. Quanto às complicações crônicas, constatou-se acidente vascular encefálico, doença arterial coronariana, neuropatia e nefropatia diabética. A maioria dos pesquisados apresentava bom controle glicêmico e utilizava antidiabético oral. Com relação à função renal, houve predomínio de insuficiência renal leve – estágio 2. Avaliando a situação nutricional, observou-se prevalência de obesidade na população geral e sobrepeso nos idosos.  Torna-se de suma importância o reconhecimento dos diabéticos e de suas condições de saúde, a fim de identificar as suas necessidades e adequar as ações assistenciais, oportunizado um cuidado integral e qualificado.',
        doi: 'https://doi.org/10.56083/RCV3N3-030',
        link: 'https://ojs.revistacontemporanea.com/ojs/index.php/home/article/view/499',
        url: 'https://bitrix24public.com/biaticefb.bitrix24.com.br/docs/pub/a52ca4966d517633e8cf38aaf22f4031/default/?&',
      },
      {
        id: '3',
        tipo: 'Artigo científico',
        titulo:
          'Utilização do processo de avaliação e monitoramento aliado ao uso da ferramenta computacional êsus Feedback na melhoria dos indicadores da atenção primária no município de serranópolis de minas-MG',
        autor: 'Almir Rogério da Silva Lopes',
        autores: [
          'Almir Rogério da Silva Lopes',
          'Melise Carina Duarte de Almeida',
        ],
        ano: '2022',
        resumo: `O Previne Brasil se apresenta como um novo modelo de financiamento da atenção primária a saúde, não sendo mais fixo e agora baseado em 3 componentes que são: capitação ponderada, indicadores de desempenho e as ações estratégicas. Sendo que, os indicadores de desempenho são divididos em: apoio ao Cuidado a Gestante cujos componentes são as consultas de pré-natal, exames de HIV e Sífilis e Consultas Odontológicas; a Saúde da Mulher que compõe o percentual de coletas de Citopatológicos; a Imunização das crianças até um ano de idade com a aplicação das vacinas Pólio e Penta e por fim o cuidado com as Doenças Crônicas onde são avaliados o percentual de Solicitação de Hemoglobina Glicada dos diabéticos e de Acompanhamento aos hipertensos; que ao final nos dará o ISF (Indicador Sintético Final) cuja variação é de 0 a 10, sendo o mínimo aceitável 7. O trabalho teve como objetivo principal a melhoria desses Indicador que prospecta o nível de acompanhamento da população por parte dos profissionais da Atenção Primária a Saúde. Neste contexto, localmente, verificamos problemas tais como: diminuição do fluxo de pacientes em decorrência da Pandemia, falta de qualificação dos profissionais, ausência de
uma ferramenta de gerenciamento adequado além de poucas ações estratégicas nas equipes. Para o processo de intervenção utilizamos a ferramenta de gestão em saúde conhecida como êSUS Feedback aliado a processos de qualificação utilizando ferramentas computacionais além de semestralmente serem feitos processos de Avaliação e Monitoramento das ações das equipes. A verificação dos resultados alcançados foi baseada nas fontes reais dos resultados do Indicador Sintético Final (ISF), composto pelos indicadores de desempenho, desde o primeiro quadrimestre de 2018 até o terceiro quadrimestre de 2021, de forma quantitativa, através de relatórios públicos presentes no portal do SISAB. Percebeu-se uma melhoria excelente nos indicadores, onde o município passou de uma nota 3.08 no primeiro quadrimestre de 2021 para 9.8 no terceiro quadrimestre de 2021, isto mostra uma melhoria de 318%.`,
        doi: '',
        link: '',
        url: 'https://bitrix24public.com/biaticefb.bitrix24.com.br/docs/pub/a52ca4966d517633e8cf38aaf22f4031/default/?&',
      },
      {
        id: '4',
        tipo: 'Apresentação',
        titulo:
          'SISTEMA DIGITAL DE GESTÃO NA ATENÇÃO PRIMÁRIA À SAÚDE: ESTUDO DE VALIDAÇÃO',
        autor: 'Mailson Silva de Oliveira',
        autores: [],
        ano: '2024',
        resumo: '',
        doi: '',
        link: '',
        url: 'https://bitrix24public.com/biaticefb.bitrix24.com.br/docs/pub/a52ca4966d517633e8cf38aaf22f4031/default/?&',
      },
      {
        id: '5',
        tipo: 'eBook',
        titulo: 'Gestão pública na região amazônica',
        autor: 'Juliano Milton Kruger',
        autores: [
          'Juliano Milton Kruger',
          'Daniel Cerdeira de Souza',
          'Taiã Mairon Peixoto Ribeiro',
          'Tânia Midian Freitas de Souza',
        ],
        ano: '2023',
        resumo: `O medicalizar consiste em interpretar assuntos de natureza pessoal, política,
econômica e social do ponto de vista médico, patologizando a vida cotidiana.
Nosso objetivo foi analisar a literatura publicada no formato de artigos científicos
publicados entre 2017-2021 sobre medicalização na escola no contexto
brasileiro. O estudo consiste em uma revisão integrativa, que analisou 25 artigos
coletados no Portal Periódicos CAPES e na Biblioteca Virtual de Saúde. Os
dados foram analisados a partir de um protocolo de revisão e posteriormente
pelo procedimento de Análise de Conteúdo. Os dados extraídos dos artigos
possibilitaram a construção de cinco categorias: 1) Medicalização no âmbito
escolar; 2) Caráter individual dos problemas escolares; 3) Medicalização como
salvação; 4) Fracasso escolar e o não-aprender; 5) Educação reducionista,
que discutiram que a escola usa da medicalização para justificar o fracasso
escolar, sem se responsabilizar pela produção deste fenômeno, além de
que a medicalização parece assumir um papel salvacionista nos contextos
escolares. Concluímos que o ambiente escolar se encontra atravessado pelo
conhecimento científico da área da saúde e que busca no campo da medicina
a solução para os problemas de aprendizagem e comportamento, por fim, propomos
a utilização do Desenho Universal para a Aprendizagem para romper
com práticas medicalizantes na escola.`,
        doi: '',
        link: '',
        url: 'https://bitrix24public.com/biaticefb.bitrix24.com.br/docs/pub/a52ca4966d517633e8cf38aaf22f4031/default/?&',
      },
      {
        id: '6',
        tipo: 'ANAIS',
        titulo:
          'ANAIS DA 84ª SEMANA BRASILEIRA DE ENFERMAGEM E 53ª JORNADA MARANHENSE DE ENFERMAGEM VALORIZAÇÃO DO TRABALHO EM ENFERMAGEM COM DESENVOLVIMENTO SUSTENTÁVEL E BEM VIVER',
        autor: 'Maria Lucia Holanda Lopes',
        autores: [
          'Maria Lucia Holanda Lopes',
          'Silvia Cristina Viana Silva Lima',
          'Patrícia Ribeira Azevedo',
          'Nair Portela Silva Coutinho',
          'Dorlene Maria Cardoso de Aquino',
          'Michael Jackson S. dos Santos',
        ],
        ano: '2023',
        resumo: `Introdução: a Enfermagem tem um papel relevante nas lutas políticas contra as desigualdades sociais, sobretudo, aquelas que tratam de pautas pela igualdade de gênero e participação política da mulher, que decorrem da luta política do movimento feminista que reivindicava a liberdade de representação no trabalho. Objetivo: evidenciar as lutas políticas da Enfermagem pela sua valorização, reconhecimento e combate das desigualdades sociais, com ênfase no fator gênero. Descrição Metodológica: revisão integrativa levantada nas bases de dados LILACS e Scielo; o critério de inclusão dos artigos residiu naqueles que foram publicados a partir do ano de 2019. Descritores: lutas políticas da Enfermagem; enfrentamento das desigualdades sociais e questão de gênero. Resultados: as lutas políticas do movimento feminista e das profissionais de Enfermagem constituíram e constituem quebras de paradigmas necessários para a valorização e reconhecimento dessas profissionais e de suas expressões no tecido social; as desigualdades no campo da Enfermagem estão diretamente relacionadas, sobretudo, a questões de gênero. Conclusão: as desigualdades sociais deferidas contra a classe de profissionais de Enfermagem são potencializadas quando se trata do universo feminino, o que evidencia a discriminação de gênero que ainda é um estigma cultural e estrutural no contexto brasileiro; a desigualdade de gênero no campo da Enfermagem é produto de um sistema patriarcal, sexista e de validação da divisão sexual do trabalho. Contribuições/Implicações para a Enfermagem: o levante das lutas políticas em favor da Enfermagem incide positivamente na assistência à saúde com qualidade, regulação e prática da profissão, promoção de formação continuada, dentre outros aspectos.`,
        doi: '',
        link: '',
        url: 'https://bitrix24public.com/biaticefb.bitrix24.com.br/docs/pub/a52ca4966d517633e8cf38aaf22f4031/default/?&',
      },
      {
        id: '7',
        tipo: 'Artigo científico',
        titulo:
          'Assistência aos hipertensos e diabéticos em uma unidade de saúde da família baseada no desempenho dos indicadores do Previne Brasil',
        autor: 'Cássio Bernardino Pinto Mangueira',
        autores: [
          'Cássio Bernardino Pinto Mangueira',
          'Milena Nunes Alves de Sousa',
        ],
        ano: '2024',
        resumo: `O presente estudo analisou o desemprenho da Unidade de Saúde da Família (USF) Miguel Morato
situada no município de Itaporanga-PB frente à assistência prestada aos hipertensos e diabéticos através das
informações disponíveis no e-SUS e no SISAB. Foram avaliadas a cobertura de visitas domiciliares realizadas pelos
Agentes Comunitários de Saúde (ACS) aos Hipertensos e Diabéticos, a cobertura de atendimento médico e de
enfermagem realizados pela USF, a quantidade de diabéticos com exame de hemoglobina glicada realizadas, a
quantidade de consultas em hipertensos e aferição de PA realizadas pela USF. A cobertura de atendimento médico
e de enfermagem aos usuários hipertensos e/ou diabéticos foi avaliada através dos indicadores de desempenho de nº
6 e 7 do Previne Brasil. Ainda, as características sociodemográficas dos munícipes foram coletadas para
compreensão dos determinantes sociais que podem impactar na condição de saúde dos usuários. Dentre os 2898
usuários adscritos na USF, 1975 (68%) encontram-se com o cadastro atualizado e 937 (32%) desatualizados, estando
acima da média em relação ao município quanto à atualização dos cadastros. Destes, 112 são diabéticos, 385
hipertensos e 79 são hipertensos e diabéticos. Em relação a cobertura de visitas domiciliares realizadas pelo ACS,
63% das famílias cadastradas foram visitadas nos últimos 30 dias. Em relação ao desempenho dos indicadores 6 e
7, a USF superou a proporção de atendimentos realizados em relação ao município como um todo, realizando 583
atendimentos aos diabéticos nos últimos 2 semestres e 484 atendimentos a hipertensos no último semestre. O estudo
limitou-se a avaliação apenas das informações disponíveis nas plataformas, não podendo dessa forma avaliar o
impacto desses números da condição de saúde dos usuários. Fornecer subsídios para monitoramento por parte da
gestão o desempenho dos profissionais pode contribuir para o planejamento de ações futuras e fomentar a solicitação
de incrementos financeiros.`,
        doi: '',
        link: '',
        url: 'https://bitrix24public.com/biaticefb.bitrix24.com.br/docs/pub/a52ca4966d517633e8cf38aaf22f4031/default/?&',
      },
      {
        id: '8',
        tipo: 'Artigo científico',
        titulo:
          'Avaliação do atributo acessibilidade na concepção das mulheres sobre a assistência ginecológica',
        autor: 'Luana Evelyng Lopes Ferreira',
        autores: [
          'Luana Evelyng Lopes Ferreira',
          'Moisés Celestino de Aguiar',
          'Arlete Rodrigues Chagas da Costa',
          'Lara Mabelle Milfont Boeckmann',
          'Suderlan Sabino Leandro',
          'Ageu Procópio Almeida de Albuquerque',
          'Rafaella Dayanny Lacerda Bomfim Soares',
        ],
        ano: '2024',
        resumo:
          'Objetivo: Avaliar o atributo acessibilidade na concepção das mulheres sobre a assistência ginecológica em uma Unidade Básica de Saúde do Distrito Federal, Brasil. Método: Trata-se de um estudo descritivo exploratório do tipo transversal com abordagem quantitativa. Resultados: Mostraram que majoritariamente o atributo acessibilidade na Atenção Primária em saúde ainda é um grande embate, e várias problemáticas persistem como as barreiras geográficas e o acesso dificultado pela organização do serviço, o que evidencia a necessidade de romper com as práticas de cuidado cotidianas que dificultam a entrada, o acesso, o acolhimento e a transmissão de informação. Conclusão: É preciso organizar formas de ofertas de saúde mais inclusivas, que visem um acolhimento de qualidade, com uma visão holística do ser como um todo, fundamental para melhor organização do sistema de serviços de saúde nas regiões de saúde.',
        doi: '',
        link: 'https://clium.org/index.php/edicoes/article/view/2921',
        url: 'https://bitrix24public.com/biaticefb.bitrix24.com.br/docs/pub/a52ca4966d517633e8cf38aaf22f4031/default/?&',
      },
      {
        id: '9',
        tipo: 'Artigo científico',
        titulo:
          'Análise dos indicadores de desempenho da atenção primária do município de Porto Velho – RO',
        autor: 'Gabriel Chiarelli Dias',
        autores: [
          'Gabriel Chiarelli Dias',
          'Rafael Saraiva Carvalho',
          'Ahmed Muhammad Zaglout',
          'Fabiano Patricio Resende',
          'Leonardo Pappis Orso',
          'Pedro Henrique Nascimento Miguel',
          'Ulisses Gonçalves Norberto',
          'Victor Alves de Oliveira',
          'Layza Karyne Farias Mendes',
          'Suyane da Costa Oliveira',
        ],
        ano: '2024',
        resumo: `Objetivo: Avaliar os indicadores de desempenho da atenção primária (Portaria n° 2.979/2019 – Programa Previne Brasil) do município de Porto Velho – RO e identificar reflexos da perda financeira por desempenho. Métodos: Utilizou-se o Sistema de Informação em Saúde da Atenção Básica (SISAB) para recuperar os resultados dos sete indicadores do Programa Previne Brasil nos três quadrimestres de 2022. O eSUS feedback foi utilizado para avaliar o desempenho geral do município de 2018 a 2022. As perdas financeiras relativas ao Indicador Sintético Final (ISF) foram identificadas através do Fundo Nacional de Saúde. Resultados: Porto Velho possui uma população estimada de 548.952 habitantes (IBGE). No último quadrimestre de 2022 alcançou-se o maior número de indivíduos cadastrados na Atenção Básica do município (323.648). Quanto aos indicadores do Programa Previne Brasil, com exceção dos exames de sífilis e HIV em gestantes no último quadrimestre de 2022, os demais indicadores e o ISF ficaram abaixo das metas do Ministério da Saúde no período analisado, ocasionando perdas financeiras superiores a 2,5 milhões de reais. Conclusão: Os indicadores do Previne Brasil em Porto Velho encontram-se abaixo das metas estabelecidas pelo Ministério da Saúde, tendo os cadastros um reflexo direto nos indicadores e consequentemente no Índice Sintético Final.`,
        doi: '',
        link: '',
        url: 'https://bitrix24public.com/biaticefb.bitrix24.com.br/docs/pub/a52ca4966d517633e8cf38aaf22f4031/default/?&',
      },
      {
        id: '10',
        tipo: 'Artigo',
        titulo:
          'Estratégias para melhoria da cobertura vacinal de Itabaianinha (SE) com parcerias intersetoriais',
        autor: 'Suelly Lima dos Santos',
        autores: [],
        ano: '2023',
        resumo: '',
        doi: '',
        link: 'https://ideiasus.fiocruz.br/praticas/estrategias-para-melhoria-da-cobertura-vacinal-de-itabaianinha-com-parcerias-intersetoriais-se/',
        url: 'https://bitrix24public.com/biaticefb.bitrix24.com.br/docs/pub/a52ca4966d517633e8cf38aaf22f4031/default/?&',
      },
      {
        id: '10-1',
        tipo: 'Artigo científico',
        titulo:
          'Continuous six-month follow-up of patients with diabetes and hypertension: how to bring those people to the health unit?',
        autor: 'David Alex Magalhães Barreira',
        autores: [
          'David Alex Magalhães Barreira',
          'Milena Nunes Alves de Sousa',
        ],
        ano: '2024',
        resumo:
          'Affecting almost 20% of the population, Systemic Arterial Hypertension is a chronic disease characterized by high blood pressure levels, influenced by genetic, epigenetic, social and environmental factors. Diabetes Mellitus (DM) is characterized by insufficient production and/or malabsorption of insulin. Both are directly related, especially when without good control, with poor outcomes in several other pathologies. This is a descriptive study, of the experience report type, developed at the Basic Health Unit Metódio de Araújo Leitão, in the Municipality of Patos-PB, in the second half of 2022, using the problematizing method proposed by Arco de Charles Maguerez as a guide. After applying the method, it was seen that there was a deficit in the unit in the performance indicators proposed by the Ministry of Health, regarding the monitoring of hypertensive and diabetic patients, and this was the key point of application of the work, in order to bring these patients for follow-up in the unit. Focusing mainly on our initial problem, related to hypertensive and diabetic patients, we saw a jump in the period in question with the application, leaving a follow-up percentage of 30% for hypertensive and 34% for diabetics in the month of June 6/2022, with a peak in the month of August 8/2022, when we reached 53% of hypertensives and 56% of hypertensives, maintaining good levels until the end of the year. Thus, the Arch of Maguerez proved to be, as a method, resolving issues such as the one we applied, mainly due to its steps of easy application and systematization. As well as we saw that the active search is the main way to bring these patients to age for follow-up, as well as the need for participation of the entire team.',
        doi: 'https://doi.org/10.55905/revconv.17n.2-106',
        link: 'https://ojs.revistacontribuciones.com/ojs/index.php/clcs/article/view/4397',
        url: 'https://bitrix24public.com/biaticefb.bitrix24.com.br/docs/pub/a52ca4966d517633e8cf38aaf22f4031/default/?&',
      },
      {
        id: '11',
        tipo: 'TCC',
        titulo:
          'INDICADOR DE DESEMPENHO PREVINE BRASIL NOS MUNICÍPIOS DA MESORREGIÃO SUL CATARINENSE SOB A ÓTICA DOS ENFERMEIROS',
        autor: 'LETHÍCIA BORGES',
        autores: [],
        ano: '2023',
        resumo: `O SUS é um dos maiores sistemas de saúde pública do mundo e que
abrange desde os a atendimentos mais simples aos mais complexos, garantindo a
saúde como um todo, desde o início ao final do processo de saúde de cada
indivíduo. No entanto, por ser este grande sistema de saúde, sofre com baixo
financiamento, gestão despreparada e profissionais que necessitam de educação
permanente relacionado a gestão de serviços. O programa Previne Brasil surge
como um incentivador de melhoria no SUS, com indicadores de desempenho que
devem ser alcançados para obtenção de uma boa classificação, fazendo com que
assim as unidades básicas de saúde consigam um repasse financeiro maior.
Objetivo: O presente estudo teve como objetivo identificar o desempenho do
Programa Previne Brasil, nos municípios da mesorregião Sul Catarinense conforme
portaria nº 2.979/2019. Metodologia: Trata-se de uma pesquisa qualitativa de
cunho descritivo e exploratório com delineamento transversal. Foi realizada através
da análise dos indicadores nos 45 municípios compostos desta região e com a
participação de enfermeiros que trabalham nestes municípios. A análise dos dados
foi realizada a partir da análise de conteúdo. Resultados: Todos os municípios da
Mesorregião do Sul Catarinense começaram o programa com notas insatisfatórias,
entretanto conseguiram se adaptar e melhorar os indicadores de desempenho a
cada novo quadrimestre, entre os entrevistados a grande dificuldade apontada por
eles foi a dificuldade de incompatibilidade de dados dos sistemas utilizados.
Conclusão: Foi possível constatar que o programa Previne Brasil incentivou a
melhoria no desempenho das unidades de saúde pública da Mesorregião Sul
Catarinense.`,
        doi: '',
        link: 'http://200.18.15.28/bitstream/1/10547/1/Leth%C3%ADcia%20Borges.pdf',
        url: 'https://bitrix24public.com/biaticefb.bitrix24.com.br/docs/pub/a52ca4966d517633e8cf38aaf22f4031/default/?&',
      },
      {
        id: '12',
        tipo: 'Artigo científico',
        titulo:
          'EXAME CITOLÓGICO: CONHECIMENTO E PRÁTICA DE UM GRUPO DE MULHERES ATENDIDAS NA REDE PÚBLICA DE SAÚDE',
        autor: 'Vanessa Vieira Eufrasio',
        autores: [
          'Vanessa Vieira Eufrasio',
          'Giovani Amado Rivera',
          'Erta Soraya Ribeiro César Rodrigues',
          'Keylla de Lacerda Brandao',
        ],
        ano: '2023',
        resumo:
          'O exame citopatológico é um teste realizado para detectar alterações nas células do colo do útero. Sua finalidade é a detecção da doença em busca de prevenir o câncer de colo de útero, pois, a partir da identificação de lesões pré-malignas, é possível trata-las para não permitir sua evolução. Neste contexto, objetivou-se avaliar o nível de conhecimento das mulheres acerca do exame citopatológico no município de Coremas-PB, bem como a identificação do perfil dessas mulheres. A metodologia utilizada para a coleta de dados trata-se de uma pesquisa de campo, exploratória do tipo descritiva com abordagem quantitativa, baseada na aplicação de um questionário impresso pré-estabelecido pela autora, e aplicado em mulheres que realizam o exame citopatológico na Unidade Básica de Saúde da cidade de Coremas – PB. Foram analisados os resultados de 32 participantes, onde 96,9% delas são consideradas adultas com idade entre 20 e 59 anos (M=38; DP=10,8). Como principais resultados, 100% das mulheres responderam ter conhecimento acerca da importância da realização e do rastreamento do exame citopatológico, bem como diagnosticar o câncer do colo do útero. Entre elas, 93,8% já realizaram o exame citopatológico e 37,5% delas fazem isso anualmente. Em relação aos fatores associados a não realização do exame, 59,4% responderam que seria por falta de interesse. Quanto as razões que as levam a não realização do exame, 36,4% delas disseram que não o faz pela demora do resultado. Dessa forma, conclui-se que, no geral, as respostas das participantes foram positivas acerca do conhecimento do exame, porém, apesar desse conhecimento específico, ainda algumas delas nunca realizaram o exame citológico (ou realizam raramente).',
        doi: '',
        link: 'https://enfermagemesaude.unifip.edu.br/index.php/enfermagemesaude/article/view/76/33',
        url: 'https://bitrix24public.com/biaticefb.bitrix24.com.br/docs/pub/a52ca4966d517633e8cf38aaf22f4031/default/?&',
      },
      {
        id: '13',
        tipo: 'Manual',
        titulo:
          'Manual Operacional - Sistema Digital de Gestão na Atenção Primária Saúde',
        autor: 'Mailson Silva de Oliveira',
        autores: [
          'Mailson Silva de Oliveira',
          'Fábio Júnior Francisco da Silva',
          'Fernando Lopes e Silva Júnior',
        ],
        ano: '2024',
        resumo: `Bem-vindo ao manual operacional do eSUS Feedback, um
software web de gestão em saúde desenvolvido para a
modernização e aprimoramento do monitoramento e avaliação das
ações e serviços de saúde ofertados pela Atenção Primária à Saúde
(APS) no Brasil. O eSUS Feedback surge como uma ferramenta
essencial para apoiar a gestão eficiente e eficaz dos serviços de
saúde, melhorando a gestão da informação em saúde e facilitando
o acompanhamento de ações estratégicas e indicadores de
desempenho no âmbito do cofinanciamento federal da APS.
Este sistema é concebido para ser intuitivo e de fácil utilização,
permitindo que os profissionais de saúde se concentrem na
prestação de cuidados de qualidade sem a preocupação com
custos adicionais, uma vez que o uso do eSUS Feedback não
acarreta ônus adicional. No entanto, é imprescindível que a
Secretaria Municipal de Saúde adquira a licença necessária para
que os profissionais possam acessar todas as funcionalidades
oferecidas pelo sistema.
Ao longo deste manual, forneceremos orientações sobre como
utilizar o eSUS Feedback de maneira eficiente, abrangendo desde o
cadastro inicial até a operação diária para resolução de problemas
comuns. Nosso objetivo é garantir que todos os profissionais com
atuação na APS estejam plenamente capacitados para aproveitar
ao máximo os recursos do sistema, contribuindo para a melhoria
contínua dos serviços de saúde na APS.
A implementação do eSUS Feedback nas unidades de saúde
representa um passo significativo rumo a inovação na gestão da
saúde pública, promovendo um sistema mais ágil, transparente e
seguro, capaz de diminuir a sobrecarga de trabalho dos gestores ao
fornecer informações em tempo hábil para a tomada de decisões.
Esperamos que este manual seja uma ferramenta valiosa para
todos os profissionais envolvidos e que a utilização do eSUS
Feedback transforme positivamente a experiência de gestão e
atendimento na APS.`,
        doi: '',
        link: '',
        url: 'https://bitrix24public.com/biaticefb.bitrix24.com.br/docs/pub/a52ca4966d517633e8cf38aaf22f4031/default/?&',
      },
    ]
  },
}
</script>

<style>
#uso-cientifico {
  margin-top: 0px;
}
</style>
